exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scale[data-v-37a4471e]{-webkit-transition:.2s;transition:.2s}.scale[data-v-37a4471e]:hover{-webkit-box-shadow:0 0 11px rgba(33,33,33,.2);box-shadow:0 0 11px rgba(33,33,33,.2)}.media-video[data-v-37a4471e]{width:100%;max-height:140px;height:140px}.mainColor[data-v-37a4471e]{display:block;width:198px;height:140px;font-size:100px;margin-bottom:5px!important;padding:20px;color:var(--main-icon-color)}.file a[data-v-37a4471e]{cursor:pointer}button .file[data-v-37a4471e]{text-align:center}button[data-v-37a4471e]{background:none;border-style:none;border:none;-webkit-box-sizing:content-box;box-sizing:content-box;cursor:pointer;display:inline;font:inherit;height:auto;padding:0;-webkit-perspective-origin:0 0;perspective-origin:0 0;text-align:start;-webkit-transform-origin:0 0;transform-origin:0 0;width:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37a4471e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/media_item.vue
// module id = 05Vg
// module chunks = 0